import type {TypedUseSelectorHook} from "react-redux";
import {useDispatch, useSelector} from "react-redux";

import type {AppDispatch, IRootState} from "../../web/src/store/store";

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
